import { routes } from './routes';
import Empresas from './empresas';
import Pessoas from './pessoas';
import Cotacoes from './cotacoes';
import Vendedores from './vendedores';
import ClientesLegacy from './clientes_legacy';
import Propostas from './propostas';
import CrmService from './crm.service.ts';
import CrmLegacyService from './crm.legacy.service';
export default angular.module('app.crm', [Empresas, Pessoas, Cotacoes, Vendedores, ClientesLegacy, Propostas]).config(routes).service('CrmService', CrmService).service('CrmLegacyService', CrmLegacyService).name;
